export default class Routes {
    // auth
    authRoute() {
        return process.env.VUE_APP_TRANSLATION_API_URL + "/auth/login";
    }

    // labels
    translationsList() {
        return process.env.VUE_APP_TRANSLATION_API_URL + "/translations";
    }
    archivedTranslationsList() {
        return process.env.VUE_APP_TRANSLATION_API_URL + "/archived-translations";
    }
    addLabel() {
        return process.env.VUE_APP_TRANSLATION_API_URL + "/translations";
    }
    updateLabel(label) {
        return process.env.VUE_APP_TRANSLATION_API_URL + "/translations/" + label;
    }
    deleteLabel(label) {
        return process.env.VUE_APP_TRANSLATION_API_URL + "/translations/" + label;
    }
    restoreLabel(label) {
        return process.env.VUE_APP_TRANSLATION_API_URL + "/archived-translations/" + label;
    }

    //tags
    tagsList() {
        return process.env.VUE_APP_TRANSLATION_API_URL + "/tags";
    }
    addTag() {
        return process.env.VUE_APP_TRANSLATION_API_URL + "/tag";
    }
}